import { authActions, authStore } from '../../store/authStore';
import { roleActions } from '../../store/roleStore';
import { useEffect, useState } from 'react';

export const useInitTokensHook = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    const init = async () => {
      await authActions.initAuth();
      roleActions.initRole(authStore.isAuthenticated, authStore.user);
      setIsInitialized(true);
    };
    init();
  }, []);

  return isInitialized;
};
